// App.js
import React from "react";
import { fetchAllCollectionsData } from "./allDataFun";

function App() {
  const handleExportData = async () => {
    const jsonData = await fetchAllCollectionsData();
    console.log(jsonData);

    // Here you can download the JSON file if needed
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "collectionsData.json";
    a.click();
  };

  return (
    <div>
      <h1>Export Firestore Data</h1>
      <button onClick={handleExportData}>Export Data as JSON</button>
    </div>
  );
}

export default App;
